import { useState, useEffect, useCallback } from 'react';
import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import AsideNavbar from 'src/components/AsideNavbar';
import PortalNavBar from 'src/components/PortalNavbar';
import './style.css';
import { VENDORS_PORTAL_API_URL } from 'src/constants/urls';
import { ProductsService } from 'src/services/Products';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import Switch from 'react-switch';
import { useUserContext } from 'src/contexts/UserContext';
import ModalComponent from 'src/components/Modal/ModalComponent';
import ButtonPedidos from 'src/components/ButtonPedidos';
import useModal from 'src/services/hooks/useModal';
import { filterProducts } from 'src/services/utils';
import getMinimumPurchaseTagValue from '../EditProduct/utils/tags/getMinimumPurchaseTagValue';
import { pageOptions, customStyles } from './utils/pageStyles';
import formatPrice from './utils/formatPrice';
import { TableName } from './components/TableName/tableName';
import { PUBLISHED, PUBLICED_TOOLTIP } from '../../labels/labels';

import messages from './messages';
import {
  FEATURE_FLAG_BATCH_UPDATE_PRODUCT_PAGE,
  allowRedirectToNewUpdateProductPage,
} from './utils/featureFlags';
import { Rudderstack } from '../../../../analytics/rudderstack/events';

export function Products() {
  const { sendEvent, userData } = useUserContext();
  const [filteredOrders, setFilteredOrders] = useState();
  const [produtos, setProdutos] = useState();
  const [openModalComp, setOpenModal, idProd, setIdProd, reject, setReject] =
    useModal();
  const [fields, setFields] = useState({
    search: '',
    status: '',
  });

  const vendorIsBlockedToEditProduct = userData && userData.supplier_blocked;

  const fetchProducts = useCallback(async () => {
    const products = await ProductsService.getProducts();
    if (products.data) {
      const produtos = [];
      const map = new Map();
      products.data.map(product => {
        if (!map.has(product.id)) {
          map.set(product.id, true);
          return produtos.push(product);
        }
        const newProd = product;
        newProd.id += new Date().getTime();
        return produtos.push(newProd);
      });
      setProdutos(produtos);
    }
  }, []);

  const updateProductStatus = useCallback(async (id, isProductActivated) => {
    const payload = {
      status: isProductActivated,
    };

    if (!vendorIsBlockedToEditProduct) {
      ProductsService.updateProduct({ id, changesProduct: payload });
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  function handleCheckChange(id, checked) {
    setIdProd(id);
    if (checked) {
      setOpenModal(true);
    } else {
      setOpenModal(false);
      setReject(true);
    }
  }

  const onClickEditProductButton = productId => () => {
    sendEvent('product-detail', { productId });
  };

  const linkToEditProduct = (row, label, className) =>
    allowRedirectToNewUpdateProductPage ? (
      <a
        href={`${VENDORS_PORTAL_API_URL}/produto/${row.id}`}
        onClick={onClickEditProductButton(row.id)}
        className={className}
      >
        <span>{label}</span>
      </a>
    ) : (
      <Link className={className} to={`/product/details/${row.id}`}>
        <span>{label}</span>
      </Link>
    );

  const columns = [
    {
      name: (
        <TableName label="SKU" tooltip="Código de identificação do Produto" />
      ),
      cell: row =>
        linkToEditProduct(
          row,
          row.variants[0].sku ? row.variants[0].sku.split('|')[0] : '-',
          'text-dark text-decoration-none',
        ),
      left: true,
      sortable: true,
      grow: 1,
      fontWeight: 'bold',
      fontSize: '18px',
    },
    {
      name: (
        <TableName
          label="Nome"
          tooltip="Nome que o lojista visualizará na sua loja da inventa"
        />
      ),
      cell: row =>
        linkToEditProduct(
          row,
          row.name ? row.name : '-',
          'text-dark text-decoration-none p-1',
        ),
      sortable: true,
      grow: 3,
      fontWeight: 'bold',
    },
    {
      name: (
        <TableName
          label="Pedido Mínimo"
          tooltip="Quantidade mínima para a venda do seu produto na loja da inventa"
        />
      ),
      selector: event => {
        const minumumPurchaseValue = getMinimumPurchaseTagValue({
          tags: event.tags,
        });

        const displayMinimumPurchase =
          minumumPurchaseValue === 0 ? '-' : minumumPurchaseValue;

        return displayMinimumPurchase;
      },
      sortable: true,
      fontWeight: 'bold',
      grow: 3,
      center: true,
    },
    {
      name: (
        <TableName
          label="Valor"
          tooltip="Valor de seu produto na loja da inventa sem impostos"
        />
      ),
      selector: e => {
        const priceTaxe = e.variants[0].price
          ? formatPrice(e.variants[0].price)
          : 'N/A';

        if (e.tags) {
          const tags = e.tags.split(',');

          const price = tags.find(f => f.includes('PRECO ORIGINAL:'));

          if (price) {
            const newPrice = price.split(':')[1];
            return formatPrice(newPrice);
          }
          return priceTaxe || 'N/A';
        }
        return priceTaxe || 'N/A';
      },
      sortable: true,
      fontWeight: 'bold',
    },

    {
      name: <TableName label={PUBLISHED} tooltip={PUBLICED_TOOLTIP} />,
      right: true,
      grow: 2,

      cell: row => (
        <td className="w-100">
          <div className="d-flex justify-content-center">
            <Switch
              width={70}
              onColor="#222222"
              offColor="#F2F2F2"
              onHandleColor="#222222"
              offHandleColor="#222222"
              disabled={vendorIsBlockedToEditProduct}
              uncheckedIcon={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    fontSize: 15,
                    color: '#666666',
                    paddingRight: 2,
                    paddingBottom: 3,
                  }}
                >
                  não
                </div>
              }
              checkedIcon={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    fontSize: 15,
                    color: '#F2F2F2',

                    paddingRight: 2,
                    paddingBottom: 3,
                  }}
                >
                  sim
                </div>
              }
              checked={row.status === 'active'}
              onChange={checked => {
                handleCheckChange(row.id, checked);
              }}
            />
          </div>
        </td>
      ),
      center: true,
    },
    {
      cell: row =>
        row.id ? (
          <td>
            {linkToEditProduct(
              row,
              <ButtonPedidos type="Detalhes" />,
              'change-link',
            )}
          </td>
        ) : (
          <td>
            <div className="change-link"> - </div>
          </td>
        ),
      right: true,
    },
  ];

  useEffect(() => {
    const products = filterProducts(produtos, fields);
    setFilteredOrders(products);
  }, [fields, produtos]);

  const onClickBatchUpdateButton = () => {
    Rudderstack.event('fp/product/edit_products_by_sheets_clicked');
  };

  return (
    <div id="wrapper">
      <AsideNavbar />
      <div id="page-wrapper">
        <PortalNavBar />
        {/* MODAL ACTIVAR */}
        {!!(idProd && openModalComp) && (
          <ModalComponent
            title="Ativação de produto"
            closeModal={() => setOpenModal(false)}
          >
            <p className="card-text pb-3">
              O produto ficará disponível para todos os lojistas da Inventa
              realizarem pedidos.
              <br /> Deseja ativar o produto?
            </p>
            <button
              className="btn btn-confirm"
              onClick={() => {
                const newProducts = produtos.map(item => {
                  if (item.id === idProd) {
                    Object.assign(item, { status: 'active' });
                    return item;
                  }
                  return item;
                });

                updateProductStatus(idProd, true);
                setProdutos(newProducts);
                sendEvent('product-active', { producId: produtos.id });
                setOpenModal(false);
              }}
            >
              Ativar Produto
            </button>
          </ModalComponent>
        )}
        {/* MODAL DESACTIVAR */}
        {idProd && reject ? (
          <ModalComponent title="Atenção" closeModal={() => setReject(false)}>
            {produtos &&
            produtos.some(e => {
              const { id, variants } = e;
              return (
                idProd === id && Array.isArray(variants) && variants.length > 1
              );
            }) ? (
              <>
                <p className="card-text">
                  Você está alterando um produto que possui mais de uma opção, a
                  disponibilidade de todas as opções abaixo serão afetadas com
                  esta ação:
                </p>
                <ul className="list-scrollable">
                  {produtos
                    .filter(
                      ({ id, variants }) =>
                        id === idProd && Array.isArray(variants),
                    )
                    .map(({ variants }) => {
                      const list = variants.map(i => {
                        const { id, title } = i;
                        return <li key={id}>{title}</li>;
                      });

                      return list;
                    })}
                </ul>
                <p className="card-text">Por favor confirme a alteração:</p>
              </>
            ) : (
              <>
                <h2 className="pb-3 fw-light fs-4">Desativação de produto</h2>

                <p className="card-text pb-3">
                  O produto será desativado temporariamente do seu catálogo
                  virtual na Inventa, impedindo os lojistas de comprarem este
                  item até que o mesmo volte ao estoque e seja reativado por
                  você.
                  <br /> Deseja desativar o produto?
                </p>
              </>
            )}

            <button
              className="btn btn-contact"
              onClick={() => {
                const newProducts = produtos.map(item => {
                  if (item.id === idProd) {
                    Object.assign(item, { status: 'draft' });
                    return item;
                  }
                  return item;
                });
                updateProductStatus(idProd, false);
                sendEvent('product-disable', { productId: produtos.id });
                setProdutos(newProducts);
                setReject(false);
              }}
            >
              Desativar Produto
            </button>
          </ModalComponent>
        ) : null}
        <div className="px-md-5 py-4" id="products-wrapper">
          <div className="row">
            <div className="col-12">
              <h1 className="title-section display-5 mb-4 fw-light">
                <FormattedMessage {...messages.pageTitle} />
              </h1>
            </div>
            <div className="col-8">
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={10}>
                <FormattedMessage {...messages.pageSubtitle} />
              </Text>
            </div>
            {FEATURE_FLAG_BATCH_UPDATE_PRODUCT_PAGE && (
              <div className="col-4">
                <a
                  href={`${VENDORS_PORTAL_API_URL}/produto/editar-em-massa`}
                  onClick={onClickBatchUpdateButton}
                >
                  <button className="btn bulk-edit float-end mr-4 mb-4">
                    <FormattedMessage {...messages.bulkUpdate} />
                  </button>
                </a>
              </div>
            )}
          </div>

          <div className="row mb-4 d-flex align-items-center w-100">
            <div className="col-12 col-md-8 col-xl-8">
              <div className="search-bar px-3">
                <input
                  type="text"
                  name="search"
                  className="py-4"
                  id="search"
                  placeholder="Buscar por nº, nome ou valor do produto"
                  value={fields.search}
                  onChange={e => {
                    setFields({ ...fields, [e.target.name]: e.target.value });
                  }}
                />
                <i className="fas fa-search" />
              </div>
            </div>
            <div className="col-12 col-md-4 col-xl-4 pb-4">
              <label className="text-muted mb-0" htmlFor="status-select">
                Visualizar
              </label>
              <select
                className="form-select input-codigo-ras"
                aria-label="status select"
                id="status-select"
                name="status"
                value={fields.status}
                onChange={e =>
                  setFields({ ...fields, [e.target.name]: e.target.value })
                }
              >
                <option defaultValue value="">
                  Todos os Status
                </option>
                <option value="active">Disponível</option>
                <option value="draft">Indisponível </option>
              </select>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <DataTable
                columns={columns}
                data={filteredOrders || []}
                pagination
                noDataComponent={
                  filteredOrders ? (
                    'Sem resultados...'
                  ) : (
                    <div className="spinner-border m-5" role="status" />
                  )
                }
                customStyles={customStyles}
                paginationComponentOptions={pageOptions}
                fixedHeader
                fixedHeaderScrollHeight="600px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
